/**
 * Product catalogue — used by both the shop grid (index.html) and the
 * product pages (product.html). Add a product here and it appears in both.
 *
 *   studio  → clean white-background shot. Always the first image shown.
 *   worn    → the shoot photo revealed on hover in the grid.
 *   gallery → everything you scroll through on the product page. The studio
 *             shot is prepended automatically, so list only the worn shots.
 */
window.NOT_SORRY_PRODUCTS = {
  "white-tee": {
    shopify: {"handle": "not-sorry-tee-white", "variants": {"M": "49204576289023", "L": "49204576321791", "XL": "49204576354559", "2XL": "49204576387327"}},
    name: "White Tee",
    price: "tee",
    meta: "Oversized · Black graffiti back print · M–2XL",
    sizes: ["M", "L", "XL", "2XL"],
    colors: [{ name: "White", id: "white-tee" }, { name: "Black", id: "black-tee" }],
    studio: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-white-tee-studio.jpg?v=1789370150",
    worn: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-white-tee-worn.jpg?v=1789370150",
    gallery: [
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-white-tee-worn.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-look-06.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-look-03.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-look-04.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-com-02.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-hero.jpg?v=1789370150",
    ],
    detail: [
      "Oversized boxy fit, drop shoulder.",
      "Black graffiti NOT SORRY print across the back, Parental Advisory tag beneath.",
      "Sizes M–2XL.",
    ],
  },

  "black-tee": {
    shopify: {"handle": "not-sorry-tee-black", "variants": {"M": "49204579729663", "L": "49204579762431", "XL": "49204579795199", "2XL": "49204579827967"}},
    name: "Black Tee",
    price: "tee",
    meta: "Oversized · White graffiti back print · M–2XL",
    sizes: ["M", "L", "XL", "2XL"],
    colors: [{ name: "White", id: "white-tee" }, { name: "Black", id: "black-tee" }],
    studio: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-black-tee-studio.jpg?v=1789370150",
    worn: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-black-tee-worn.jpg?v=1789370150",
    gallery: [
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-black-tee-worn.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-look-05.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-look-01.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-01.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-com-01.jpg?v=1789370150",
    ],
    detail: [
      "Oversized boxy fit, drop shoulder.",
      "White graffiti NOT SORRY print across the back, Parental Advisory tag beneath.",
      "Sizes M–2XL.",
    ],
  },

  "shorts": {
    shopify: {"handle": "not-sorry-shorts-black-1", "variants": {"M": "49204583497983", "L": "49204583530751", "XL": "49204583563519", "2XL": "49204583596287"}},
    name: "Shorts",
    price: "shorts",
    meta: "Black · White front-leg logo · M–2XL",
    sizes: ["M", "L", "XL", "2XL"],
    colors: [{ name: "Black", id: "shorts" }],
    studio: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-shorts-studio.jpg?v=1789370150",
    worn: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-shorts-worn.jpg?v=1789370150",
    gallery: [
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-shorts-worn.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-white-tee-worn.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-01.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-02.jpg?v=1789370150",
    ],
    detail: [
      "Drawcord waist, side pockets.",
      "White NOT SORRY logo on the front leg — not visible from behind.",
      "Sizes M–2XL.",
    ],
  },

  "cap": {
    shopify: {"handle": "not-cap-black-1", "variants": {"One size": "49204585726207"}},
    name: "NOT. Cap",
    price: "cap",
    meta: "One size · Adjustable strap",
    sizes: ["One size"],
    colors: [{ name: "Black", id: "cap" }],
    studio: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-cap-studio.jpg?v=1789370150",
    // Single clean studio shot only — there's no cap photo in the shoot, and
    // borrowed frames where a cap happens to appear looked like filler.
    // No `worn`, so the grid tile doesn't hover-swap; no gallery, so the
    // product page renders one image with no thumbnails or arrows.
    worn: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-cap-studio.jpg?v=1789370150",
    gallery: [],
    detail: [
      "Cream NOT. logo on the front panel.",
      "One size, adjustable strap.",
    ],
  },

  /* ---- bundles -------------------------------------------------------
     These are also products, so clicking a bundle card opens its own page.
     `optionGroups` drives the selectors: one row per garment in the bundle,
     since a bundle needs a size (and colour) picked for each piece.        */

  "bundle-duo": {
    shopify: {"handle": "not-sorry-bundle-tee-shorts", "variants": {"White|M": "49204590706943", "White|L": "49204590739711", "White|XL": "49204590772479", "White|2XL": "49204590805247", "Black|M": "49204590838015", "Black|L": "49204590870783", "Black|XL": "49204590903551", "Black|2XL": "49204590936319"}},
    name: "Tee + Shorts",
    isBundle: true,
    price: "duo",
    was: "duo",
    meta: "1 × Tee · 1 × Shorts",
    // variantGroups pick the real Shopify variant; propGroups ride along as
    // cart line-item properties. Shopify allows only 3 options per product, so
    // a size per garment can't all be variants — properties carry the rest
    // through to the order without restructuring the live product.
    variantGroups: [
      { label: "Tee colour", values: ["White", "Black"] },
      { label: "Tee size", values: ["M", "L", "XL", "2XL"], prop: "Tee size" },
    ],
    propGroups: [
      { label: "Shorts size", values: ["M", "L", "XL", "2XL"], prop: "Shorts size" },
    ],
    studio: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-01.jpg?v=1789370150",
    worn: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-01.jpg?v=1789370150",
    gallery: [
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-white-tee-studio.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-black-tee-studio.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-shorts-studio.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-white-tee-worn.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-02.jpg?v=1789370150",
    ],
    detail: [
      "One tee in your choice of colourway, plus the shorts.",
      "Pick the tee size and the shorts size separately — M–2XL on each.",
    ],
  },

  "bundle-trio": {
    shopify: {"handle": "not-sorry-bundle-2-tees-shorts", "variants": {"2 × White|M": "49204595491071", "2 × White|L": "49204595523839", "2 × White|XL": "49204595556607", "2 × White|2XL": "49204595589375", "2 × Black|M": "49204595622143", "2 × Black|L": "49204595654911", "2 × Black|XL": "49204595687679", "2 × Black|2XL": "49204595720447", "1 × White + 1 × Black|M": "49204595753215", "1 × White + 1 × Black|L": "49204595785983", "1 × White + 1 × Black|XL": "49204595818751", "1 × White + 1 × Black|2XL": "49204595851519"}},
    name: "2 Tees + Shorts",
    isBundle: true,
    price: "trio",
    was: "trio",
    meta: "2 × Tees · 1 × Shorts",
    variantGroups: [
      { label: "Tee combination", values: ["2 × White", "2 × Black", "1 × White + 1 × Black"] },
      { label: "Tee 1 size", values: ["M", "L", "XL", "2XL"], prop: "Tee 1 size" },
    ],
    propGroups: [
      { label: "Tee 2 size", values: ["M", "L", "XL", "2XL"], prop: "Tee 2 size" },
      { label: "Shorts size", values: ["M", "L", "XL", "2XL"], prop: "Shorts size" },
    ],
    studio: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-02.jpg?v=1789370150",
    worn: "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-02.jpg?v=1789370150",
    gallery: [
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-white-tee-studio.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-black-tee-studio.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-shorts-studio.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-bundle-01.jpg?v=1789370150",
      "https://cdn.shopify.com/s/files/1/0771/4845/5167/files/nsd-com-01.jpg?v=1789370150",
    ],
    detail: [
      "Two tees in any colour combination, plus the shorts.",
      "Pick a size for each tee and for the shorts separately — M–2XL on each.",
    ],
  },
};
